import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { AddPolicyTypeButton } from "./components/AddPolicyTypeButton";
import { PolicyTypesTable } from "./components/PolicyTypesTable";

const PolicyTypes = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Policy Types");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Policy Types" },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title="Policy Types"
                subtitle="Classify insurance policies by type"
            >
                {" "}
                <AddPolicyTypeButton />
            </AdminPageHeader>
            <div className="mt-6">
                <PolicyTypesTable />
            </div>
        </AdminPageContent>
    );
};

export default PolicyTypes;
